import { ResolvedWingViewportDefaults, WingConfig, WingResponsiveConfig } from "@nts/std/interfaces";
import { WingViewportKey } from "@nts/std/types";

export const DEFAULT_NAMED_WING_RESPONSIVE_CONFIG: Record<
  WingViewportKey,
  ResolvedWingViewportDefaults
> = {
  desktop: {
    width: '435px',
    mode: 'push',
  },
  tablet: {
    width: '435px',
    mode: 'overlay',
  },
  mobile: {
    width: '100%',
    mode: 'overlay',
  },
};

export const DEFAULT_WING_CONFIG: Required<
  Omit<WingConfig, 'guards' | 'responsive'>
> & { responsive: Required<WingResponsiveConfig>; } = {
  isInitialCollapsed: true,
  showToggle: true,
  dockMode: 'belowToolbar',
  isModal: false,
  modalOptions: {
    customOverlayClasses: [],
    isOverlayTransparent: false,
  },
  responsive: {
    named: DEFAULT_NAMED_WING_RESPONSIVE_CONFIG,
    custom: [],
  },
};
